// Preserve uniqueness for these class names

export default [
  'is-orange',
  'is-green',
  'is-pink',
  'is-blue',
];
